module.exports = __webpack_public_path__ + "img/people-sightseeing-outdoors-rafiki.ca6b34a8.svg";